import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import NeedDetailModal from "./NeedDetailModal";

const NeedDetail = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  return (
    <NeedDetailModal
      isOpen={true}
      needId={id}
      onClose={() => navigate("/portal/asap-pilot/needs")}
    />
  );
};

export default NeedDetail;

